import { atom } from 'recoil';

import {
  defaultAuthenticationState,
  defaultLoadingState,
  defaultCurrentQuoteState,
  defaultCurrentAccountState,
  defaultSearchState,
  defaultNotificationState,
  defaultBaseAccountState,
} from './defaults';

export const authenticationState = atom({
  key: 'authenticationState',
  default: defaultAuthenticationState,
});

export const loadingState = atom({
  key: 'loadingState',
  default: defaultLoadingState,
});

export const currentQuoteState = atom({
  key: 'currentQuoteState',
  default: defaultCurrentQuoteState,
});

export const baseAccountState = atom({
  key: 'baseAccountState',
  default: defaultBaseAccountState,
});

export const currentAccountState = atom({
  key: 'currentAccountState',
  default: defaultCurrentAccountState,
});

export const searchState = atom({
  key: 'searchStateState',
  default: defaultSearchState,
});

export const notificationState = atom({
  key: 'notificationState',
  default: defaultNotificationState,
});
